import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { StatCard, StatCardSkeleton } from '../components/solar/StatCard';
import { ChartCardSkeleton } from '../components/solar/ChartCardSkeleton';
import { finanzUebersicht } from '../components/objects/finanzUebersicht';
import { getOptions } from '../components/options/finanzUebersichtChart';
import { data as chartData } from '../components/data/finanzUebersichtChart';
import { Bar } from 'react-chartjs-2';
import { Card, Table, Accordion, Button, ProgressBar } from 'react-bootstrap';


class FinanzUebersichtClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            evuOpen: [],
            pvOpen: [],
            pvFinalOpen: [],
        };
        this.toggleEvu = this.toggleEvu.bind(this);
        this.togglePv = this.togglePv.bind(this);
        this.togglePvFinal = this.togglePvFinal.bind(this);
    }

    toggleEvu(id) {
        const open = [...this.state.evuOpen];
        const idx = open.indexOf(id);
        if (idx >= 0) open.splice(idx, 1);
        else open.push(id);
        this.setState({ evuOpen: open });
    }

    togglePv(id) {
        const open = [...this.state.pvOpen];
        const idx = open.indexOf(id);
        if (idx >= 0) open.splice(idx, 1);
        else open.push(id);
        this.setState({ pvOpen: open });
    }

    togglePvFinal(id) {
        const open = [...this.state.pvFinalOpen];
        const idx = open.indexOf(id);
        if (idx >= 0) open.splice(idx, 1);
        else open.push(id);
        this.setState({ pvFinalOpen: open });
    }

    componentDidMount() {
        // Alle API-Endpunkte anfordern
        for (var k in finanzUebersicht) {
            this.props.request(finanzUebersicht[k]);
        }
    }

    render() {
        return (
            <div>
                <h3>Finanzuebersicht</h3>
                {renderKPIRow(this.props)}
                {renderTilgungsFortschritt(this.props)}
                {renderChart(this.props)}
                {renderJahresTable(this.props)}
                {renderDetailAccordion(this.props, this.state, this.toggleEvu, this.togglePv, this.togglePvFinal)}
            </div>
        );
    }
}

/**
 * KPI-Zeile: Gesamteinahmen PV | Gesamtausgaben EVU | Saldo (Netto) | Restfinanzierung
 */
function renderKPIRow(props) {
    const mixedUI = props.MixedBarDiagrammEinnahmenUI || {};
    const finanzText = props.JahresFinanzierungsfortschrittUI || '';

    // BOTH-Check: isLoaded UND Daten vorhanden
    let hasData = typeof (mixedUI.Soll) !== 'undefined' && mixedUI.Soll.length > 0;
    let loading = !props.isLoaded || !hasData;

    if (loading) {
        return (
            <div className="stat-cards-row">
                <StatCardSkeleton variant="energy" />
                <StatCardSkeleton />
                <StatCardSkeleton variant="progress" />
                <StatCardSkeleton />
            </div>
        );
    }

    // Summiere alle Jahreswerte
    // API: Soll = Gesamtausgaben, Ist = Saldo (Einnahmen - Ausgaben)
    let gesamtAusgaben = 0;
    let gesamtSaldo = 0;

    if (Array.isArray(mixedUI.Soll)) {
        for (let i = 0; i < mixedUI.Soll.length; i++) {
            gesamtAusgaben += Number(mixedUI.Soll[i]) || 0;
        }
    }
    if (Array.isArray(mixedUI.Ist)) {
        for (let i = 0; i < mixedUI.Ist.length; i++) {
            gesamtSaldo += Number(mixedUI.Ist[i]) || 0;
        }
    }

    // Einnahmen = Ausgaben + Saldo
    const gesamtEinnahmen = gesamtAusgaben + gesamtSaldo;
    const saldoPositiv = gesamtSaldo >= 0;

    // Extrahiere Restfinanzierung-Text aus Finanzierungsfortschritt
    let restfinanzWert = '';
    let restfinanzRaw = String(finanzText);
    const numMatch = restfinanzRaw.match(/([\d][\d,.]{2,})/);
    if (numMatch) {
        const raw = numMatch[1].replace(',', '.');
        const parsed = parseFloat(raw);
        if (!isNaN(parsed)) {
            restfinanzWert = Math.round(parsed).toLocaleString('de-DE') + ' €';
        } else {
            restfinanzWert = restfinanzRaw.substring(0, 40);
        }
    } else {
        restfinanzWert = restfinanzRaw.substring(0, 40);
    }

    return (
        <div className="stat-cards-row">
            <StatCard
                value={gesamtEinnahmen}
                label="Gesamteinahmen PV"
                unit=" €"
                icon={<i className="bi bi-cash-stack" />}
                variant="energy"
                subLabel={Math.round(gesamtEinnahmen).toLocaleString('de-DE') + ' € gesamt'}
                description="Summe aller Einnahmen aus der PV-Anlage: Einspeisevergütung plus eingesparte Stromkosten."
            />
            <StatCard
                value={gesamtAusgaben}
                label="Gesamtausgaben EVU"
                unit=" €"
                icon={<i className="bi bi-receipt" />}
                subLabel={Math.round(gesamtAusgaben).toLocaleString('de-DE') + ' € gesamt'}
                description="Alle Strombezugskosten beim Energieversorger. Inklusive Netzgebühren und Steuern."
            />
            <StatCard
                value={gesamtSaldo}
                label="Saldo (Netto)"
                unit=" €"
                icon={<i className="bi bi-graph-up-arrow" />}
                variant={saldoPositiv ? 'energy' : 'consumption'}
                subLabel={(saldoPositiv ? '+' : '') + Math.round(gesamtSaldo).toLocaleString('de-DE') + ' €'}
                description="PV-Einnahmen abzüglich Stromkosten. Positiver Wert = Anlage erwirtschaftet mehr als sie kostet."
            />
            <StatCard
                value={restfinanzWert}
                label="Finanzierung"
                unit=""
                icon={<i className="bi bi-bank" />}
                variant="progress"
                subLabel={restfinanzRaw}
                description="Verbleibender Finanzierungsrestbetrag oder bereits abbezahlter Betrag der PV-Anlage."
            />
        </div>
    );
}

/** Stacked-Bar-Chart: Ausgaben (Amber) + Saldo (Grün) pro Jahr */
function renderChart(props) {
    const apiData = props.MixedBarDiagrammEinnahmenUI || {};
    let hasData = typeof (apiData.Soll) !== 'undefined' && apiData.Soll.length > 0;

    let chartObj = { labels: [''], datasets: [{ data: [0] }, { data: [0] }] };

    if (hasData) {
        chartObj = {
            labels: apiData.Year,
            datasets: [
                { ...chartData.datasets[0], data: apiData.Soll },       // Ausgaben
                { ...chartData.datasets[1], data: apiData.Ist },        // Saldo
            ]
        };
    }

    let loading = !props.isLoaded || !hasData;

    return (
        <>
            {loading && <ChartCardSkeleton />}
            {!loading && (
                <Card className="chart-card mt-3">
                    <Card.Body>
                        <Bar data={chartObj} options={{ ...getOptions(), animation: false }} />
                    </Card.Body>
                </Card>
            )}
        </>
    );
}

/** Jahresuebersicht-Tabelle mit numerischen Werten */
function renderJahresTable(props) {
    const apiData = props.MixedBarDiagrammEinnahmenUI || {};
    let hasData = typeof (apiData.Soll) !== 'undefined' && apiData.Soll.length > 0;

    if (!props.isLoaded || !hasData) {
        return null;
    }

    const years = apiData.Year || [];
    const ausgabenArr = apiData.Soll || [];
    const saldoArr = apiData.Ist || [];

    // Berechne Einnahmen pro Jahr
    const rows = [];
    let gesamtEinn = 0;
    let gesamtAusg = 0;
    let gesamtSaldo = 0;

    for (let i = 0; i < years.length; i++) {
        const ausg = Number(ausgabenArr[i]) || 0;
        const saldo = Number(saldoArr[i]) || 0;
        const einn = ausg + saldo;
        gesamtEinn += einn;
        gesamtAusg += ausg;
        gesamtSaldo += saldo;
        rows.push({
            jahr: years[i],
            einnahmen: einn,
            ausgaben: ausg,
            saldo: saldo,
        });
    }

    return (
        <Card className="chart-card mt-3">
            <Card.Body>
                <h6>Jahresuebersicht</h6>
                <div className="table-responsive">
                    <Table striped bordered hover size="sm">
                        <thead>
                            <tr>
                                <th>Jahr</th>
                                <th className="text-end">Einnahmen (PV)</th>
                                <th className="text-end">Ausgaben (EVU)</th>
                                <th className="text-end">Saldo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r, idx) => (
                                <tr key={idx}>
                                    <td>{r.jahr}</td>
                                    <td className="text-end" style={{ color: 'rgba(34, 197, 94, 0.9)' }}>
                                        {Math.round(r.einnahmen).toLocaleString('de-DE')} €
                                    </td>
                                    <td className="text-end" style={{ color: 'rgba(251, 191, 36, 0.9)' }}>
                                        {Math.round(r.ausgaben).toLocaleString('de-DE')} €
                                    </td>
                                    <td className={"text-end " + (r.saldo >= 0 ? 'text-success' : 'text-danger')}>
                                        {Math.round(r.saldo).toLocaleString('de-DE')} €
                                    </td>
                                </tr>
                            ))}
                            <tr style={{ fontWeight: 'bold', borderTop: '2px solid #333' }}>
                                <td>Jahrgesamt</td>
                                <td className="text-end">
                                    {Math.round(gesamtEinn).toLocaleString('de-DE')} €
                                </td>
                                <td className="text-end">
                                    {Math.round(gesamtAusg).toLocaleString('de-DE')} €
                                </td>
                                <td className={"text-end " + (gesamtSaldo >= 0 ? 'text-success' : 'text-danger')}>
                                    {Math.round(gesamtSaldo).toLocaleString('de-DE')} €
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card>
    );
}

/**
 * Tilgungs-Fortschrittsanzeige: Visuelle Fortschrittsleiste fuer Kredit-Tilgung.
 * Gesamtkredit wird aus KPI-Rechnung abgeleitet oder aus dem API-Text extrahiert.
 */
function renderTilgungsFortschritt(props) {
    const mixedUI = props.MixedBarDiagrammEinnahmenUI || {};
    const finanzText = props.JahresFinanzierungsfortschrittUI || '';

    let hasData = typeof (mixedUI.Soll) !== 'undefined' && mixedUI.Soll.length > 0;
    if (!props.isLoaded || !hasData) {
        return null;
    }

    // Summiere Ausgaben (gesamter EVU-Bezug pro Jahr)
    let gesamtAusgaben = 0;
    let gesamtSaldo = 0;
    if (Array.isArray(mixedUI.Soll)) {
        for (let i = 0; i < mixedUI.Soll.length; i++) {
            gesamtAusgaben += Number(mixedUI.Soll[i]) || 0;
        }
    }
    if (Array.isArray(mixedUI.Ist)) {
        for (let i = 0; i < mixedUI.Ist.length; i++) {
            gesamtSaldo += Number(mixedUI.Ist[i]) || 0;
        }
    }

    // Einnahmen = Ausgaben + Saldo
    const gesamtEinnahmen = gesamtAusgaben + gesamtSaldo;

    // Extrahiere Restbetrag aus API-Text
    let restbetrag = 0;
    const numMatch = String(finanzText).match(/([\d][\d,.]{2,})/);
    if (numMatch) {
        const raw = numMatch[1].replace(',', '.');
        const parsed = parseFloat(raw);
        if (!isNaN(parsed)) {
            restbetrag = parsed;
        }
    }

    // Gesamtkredit = Einnahmen + Restbetrag (was bereits verdient + noch noetig)
    const gesamtKredit = gesamtEinnahmen + restbetrag;
    const tilgungsProzent = gesamtKredit > 0 ? Math.min(100, (gesamtEinnahmen / gesamtKredit) * 100) : 0;

    // Farbcodierung: >=50% gruennlich, <50% gelblich
    const variant = tilgungsProzent >= 75 ? 'success' : tilgungsProzent >= 50 ? 'warning' : 'danger';

    return (
        <Card className="chart-card mt-3">
            <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="mb-0">Tilgungs-Fortschritt</h6>
                    <span style={{ fontSize: '0.9rem' }}>
                        {tilgungsProzent.toFixed(1)}% — bereits {' '}
                        {Math.round(gesamtEinnahmen).toLocaleString('de-DE')} € von{' '}
                        {Math.round(gesamtKredit).toLocaleString('de-DE')} €
                    </span>
                </div>
                <ProgressBar variant={variant} now={tilgungsProzent} label={Math.round(tilgungsProzent) + '%'} />
                {restbetrag > 0 && (
                    <small className="mt-1 d-block text-muted">
                        Noch noetige Einnahmen: {Math.round(restbetrag).toLocaleString('de-DE')} €
                    </small>
                )}
            </Card.Body>
        </Card>
    );
}

/**
 * Detail-Akkordeon: HTML-Inhalt aus allen 3 API-Quellen (EVU, PV, PV-Jahresabrechnung).
 */
function renderDetailAccordion(props, state, toggleEvu, togglePv, togglePvFinal) {
    const evuData = props.EvuBillUI || [];
    const pvData = props.PvBillUI || {};
    const pvFinalData = props.PvFinalBillUI || [];

    // BOTH-Check: Mindestens eine Quelle muss Daten haben
    const hasEvu = Array.isArray(evuData) && evuData.length > 0;
    const hasPv = typeof pvData === 'object' && pvData.ZaehlerText && pvData.ZaehlerText.length > 0;
    const hasPvFinal = Array.isArray(pvFinalData) && pvFinalData.length > 0;

    if (!hasEvu && !hasPv && !hasPvFinal) {
        return null;
    }

    // PV MegaHeadline (gesamt)
    const pvMegaHeadline = pvData.MegaHeadline || '';

    /**
     * EVU-Rechnungen pro Jahr rendern.
     * Struktur: Array von { Year, MegaHeadline, SubHeadline[], PanelContent[] }
     */
    const renderEvuSection = () => {
        if (!hasEvu) return null;

        // Gruppieren nach Jahr (MegaHeadline enthaelt typischerweise die Jahresangabe)
        const jahreData = [];
        for (let a = 0; a < evuData.length; a++) {
            const item = evuData[a];
            const subitems = [];
            for (let i = 0; i < (item.SubHeadline || []).length; i++) {
                subitems.push({
                    headline: item.SubHeadline[i],
                    content: item.PanelContent[i],
                });
            }
            jahreData.push({
                megaHeadline: item.MegaHeadline,
                subitems: subitems,
            });
        }

        return jahreData.reverse().map((jahr, jIdx) => (
            <Card key={'evu-j-' + jIdx} className="mb-2">
                <Card.Body dangerouslySetInnerHTML={{ __html: jahr.megaHeadline }} />
                {jahr.subitems.map((sub, sIdx) => (
                    <div key={'evu-s-' + jIdx + '-' + sIdx}>
                        <Button
                            variant="info"
                            size="sm"
                            onClick={() => toggleEvu('evu-' + jIdx + '-' + sIdx)}
                            style={{ width: '100%', textAlign: 'left' }}
                            dangerouslySetInnerHTML={{ __html: sub.headline }}
                        />
                        <Accordion.Collapse in={state.evuOpen.includes('evu-' + jIdx + '-' + sIdx)}>
                            <Card className="mb-0">
                                <Card.Body>
                                    <div dangerouslySetInnerHTML={{ __html: sub.content }} />
                                </Card.Body>
                            </Card>
                        </Accordion.Collapse>
                    </div>
                ))}
            </Card>
        ));
    };

    /**
     * PV-Einspeiserechnungen pro Jahr rendern.
     * Struktur: ZaehlerText[] von { Year, MegaHeadline, SubHeadline[], PanelContent[], PanelContentGesamtText[] }
     */
    const renderPvSection = () => {
        if (!hasPv) return null;

        const jahreData = pvData.ZaehlerText || [];
        const jahreList = [];
        for (let a = 0; a < jahreData.length; a++) {
            const item = jahreData[a];
            const subitems = [];
            for (let i = 0; i < (item.SubHeadline || []).length; i++) {
                subitems.push({
                    headline: item.SubHeadline[i],
                    contentGesamt: item.PanelContentGesamtText ? item.PanelContentGesamtText[i] : '',
                    content: item.PanelContent[i],
                });
            }
            jahreList.push({
                megaHeadline: item.MegaHeadline,
                subitems: subitems,
            });
        }

        return (
            <>
                {pvMegaHeadline && (
                    <Card className="mb-2">
                        <Card.Body dangerouslySetInnerHTML={{ __html: pvMegaHeadline }} />
                    </Card>
                )}
                {jahreList.reverse().map((jahr, jIdx) => (
                    <Card key={'pv-j-' + jIdx} className="mb-2">
                        <Card.Body dangerouslySetInnerHTML={{ __html: jahr.megaHeadline }} />
                        {jahr.subitems.map((sub, sIdx) => (
                            <div key={'pv-s-' + jIdx + '-' + sIdx}>
                                <Button
                                    variant="info"
                                    size="sm"
                                    onClick={() => togglePv('pv-' + jIdx + '-' + sIdx)}
                                    style={{ width: '100%', textAlign: 'left' }}
                                    dangerouslySetInnerHTML={{ __html: sub.headline }}
                                />
                                <Accordion.Collapse in={state.pvOpen.includes('pv-' + jIdx + '-' + sIdx)}>
                                    <Card className="mb-0">
                                        <Card.Body>
                                            {sub.contentGesamt && (
                                                <div dangerouslySetInnerHTML={{ __html: sub.contentGesamt }} />
                                            )}
                                            <div dangerouslySetInnerHTML={{ __html: sub.content }} />
                                        </Card.Body>
                                    </Card>
                                </Accordion.Collapse>
                            </div>
                        ))}
                    </Card>
                ))}
            </>
        );
    };

    /**
     * PV-Jahresendabrechnung rendern.
     * Struktur: Array von { Headline, PanelContent }
     */
    const renderPvFinalSection = () => {
        if (!hasPvFinal) return null;

        return pvFinalData.map((item, idx) => (
            <div key={'pvf-' + idx}>
                <Button
                    variant="info"
                    size="sm"
                    onClick={() => togglePvFinal('pvf-' + idx)}
                    style={{ width: '100%', textAlign: 'left' }}
                    dangerouslySetInnerHTML={{ __html: item.Headline }}
                />
                <Accordion.Collapse in={state.pvFinalOpen.includes('pvf-' + idx)}>
                    <Card className="mb-0">
                        <Card.Body>
                            <div dangerouslySetInnerHTML={{ __html: item.PanelContent }} />
                        </Card.Body>
                    </Card>
                </Accordion.Collapse>
            </div>
        ));
    };

    return (
        <Card className="chart-card mt-3">
            <Card.Body>
                <h6>Detailansicht — Rechnungen</h6>

                {hasEvu && (
                    <div className="mb-3">
                        <h6><i className="bi bi-receipt" /> EVU-Stromrechnungen</h6>
                        {renderEvuSection()}
                    </div>
                )}

                {hasPv && (
                    <div className="mb-3">
                        <h6><i className="bi bi-sun" /> PV-Einspeiserechnungen</h6>
                        {renderPvSection()}
                    </div>
                )}

                {hasPvFinal && (
                    <div className="mb-3">
                        <h6><i className="bi bi-calendar-check" /> PV-Jahresendabrechnung</h6>
                        {renderPvFinalSection()}
                    </div>
                )}
            </Card.Body>
        </Card>
    );
}

export default connect(
    state => state.finanzUebersichtReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(FinanzUebersichtClass);
